var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "700" },
      model: {
        value: _vm.modal,
        callback: function($$v) {
          _vm.modal = $$v
        },
        expression: "modal"
      }
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "headline grey lighten-2" }, [
            _vm._v(" " + _vm._s(_vm.formTitle) + " ")
          ]),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _vm.item
            ? _c("div", { staticClass: "container px-8 edit-form" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-sm-12" },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Item Title",
                          "error-messages": _vm.titleErrors
                        },
                        on: {
                          input: function($event) {
                            return _vm.$v.item.title.$touch()
                          },
                          blur: function($event) {
                            return _vm.$v.item.title.$touch()
                          }
                        },
                        model: {
                          value: _vm.item.title,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "title", $$v)
                          },
                          expression: "item.title"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-sm-12" },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Item Slug",
                          "error-messages": _vm.slugErrors
                        },
                        on: {
                          input: function($event) {
                            return _vm.$v.item.slug.$touch()
                          },
                          blur: function($event) {
                            return _vm.$v.item.slug.$touch()
                          }
                        },
                        model: {
                          value: _vm.item.slug,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "slug", $$v)
                          },
                          expression: "item.slug"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-12" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.item.description,
                          expression: "item.description"
                        }
                      ],
                      attrs: { placeholder: "Item Description" },
                      domProps: { value: _vm.item.description },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.item, "description", $event.target.value)
                        }
                      }
                    })
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.unit
            ? _c("div", { staticClass: "container px-8 edit-form" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-sm-12" },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Unit Title",
                          "error-messages": _vm.unitTitleErrors
                        },
                        on: {
                          input: function($event) {
                            return _vm.$v.unit.title.$touch()
                          },
                          blur: function($event) {
                            return _vm.$v.unit.title.$touch()
                          }
                        },
                        model: {
                          value: _vm.unit.title,
                          callback: function($$v) {
                            _vm.$set(_vm.unit, "title", $$v)
                          },
                          expression: "unit.title"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-sm-6" },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Unit Price",
                          "error-messages": _vm.priceErrors
                        },
                        on: {
                          input: function($event) {
                            return _vm.$v.unit.price.$touch()
                          },
                          blur: function($event) {
                            return _vm.$v.unit.price.$touch()
                          }
                        },
                        model: {
                          value: _vm.unit.price,
                          callback: function($$v) {
                            _vm.$set(_vm.unit, "price", $$v)
                          },
                          expression: "unit.price"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-sm-6" },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Unit Volume" },
                        model: {
                          value: _vm.unit.characteristics.volume,
                          callback: function($$v) {
                            _vm.$set(_vm.unit.characteristics, "volume", $$v)
                          },
                          expression: "unit.characteristics.volume"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticClass: "headline grey lighten-2" },
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.submit()
                    }
                  }
                },
                [_vm._v(" Submit ")]
              ),
              _vm._v(" "),
              _c("v-spacer")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }